import {addDays, addMonths, format, startOfToday, subDays, subMonths} from 'date-fns';
import el from 'date-fns/locale/el';

import {removeAccents} from '../../utils/stringTools';
import {DateTab, DateTabsType} from '../../utils/types';

// BIQ: find a better location for this helper?

export const dateTabsTotal = {
  [DateTabsType.DAYS]: 29,
  [DateTabsType.MONTHS]: 7,
};

/**
 * Provides tabs for dates (14 days past + 14 future / 3 months + 3 future) based on view being filtered or not
 * @param type Type of tabs to return (days or months) based on filtering.
 */
export const getDateTabs = (type: DateTabsType): DateTab[] => {
  const {[DateTabsType.DAYS]: allDays, [DateTabsType.MONTHS]: allMonths} = dateTabsTotal;
  const halfDays = Math.floor(allDays / 2);
  const halfMonths = Math.floor(allMonths / 2);

  const today = startOfToday();
  const startingDay = subDays(today, halfDays);
  const startingMonth = subMonths(today, halfMonths);

  const days = new Array(allDays).fill(null).map((v, i) => addDays(startingDay, i));
  const months = new Array(allMonths).fill(null).map((v, i) => addMonths(startingMonth, i));

  let tabs: DateTab[] = [];

  switch (type) {
    case DateTabsType.DAYS:
      tabs = days.map((v, i) => ({
        index: i,
        labelTop:
          i === halfDays ? 'ΣΗΜΕΡΑ' : removeAccents(format(v, 'EEE', {locale: el}).toUpperCase()),
        labelBottom: removeAccents(format(v, 'd MMM', {locale: el}).toUpperCase()),
        date: format(v, 'yyyy-MM-dd'),
      }));
      break;
    case DateTabsType.MONTHS:
      tabs = months.map((v, i) => ({
        index: i,
        labelTop: removeAccents(format(v, 'MMM', {locale: el}).toUpperCase()),
        labelBottom: format(v, 'y', {locale: el}).toUpperCase(),
        date: format(v, 'yyyy-MM'),
      }));
      break;
    default:
  }

  return tabs;
};

export default {dateTabsTotal, getDateTabs};
